import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileText, Database, Settings, BarChart3 } from 'lucide-react';

const OurServices = () => {
  const services = [
    {
      icon: FileText,
      title: 'Mortgage Analytics',
      description: 'Complex loans and structured finance instruments analysis customized to client-specific requirements.',
      link: '/services#loan-origination'
    },
    {
      icon: BarChart3,
      title: 'Underwriting Services',
      description: 'Supporting due-diligence & underwriting activities for CMBS/CRE lenders, brokers, and third-party companies.',
      link: '/services#loan-origination'
    },
    {
      icon: Database,
      title: 'Lease Administration',
      description: 'Lease Abstraction, Lease Audit, CAM Audit, CAM/TAX Year-End Reconciliations and Recovery services.',
      link: '/services#lease-administration'
    },
    {
      icon: Settings,
      title: 'Technology Solutions',
      description: 'Custom dashboards, reporting tools, and CRE technology consulting for modern operations.',
      link: '/services#consulting'
    }
  ];

  return (
    <section className="relative py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-[#005B63]/10 rounded-full text-[#005B63] text-sm font-medium mb-4">
            What We Do
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Our Core Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive commercial real estate outsourcing solutions tailored to your needs
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-8 hover:border-[#005B63]/50 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#005B63]/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#005B63] transition-colors">
                  <service.icon className="w-7 h-7 text-[#005B63] group-hover:text-white transition-colors" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#005B63] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>
                  <Link
                    to={service.link}
                    className="inline-flex items-center gap-2 text-[#005B63] hover:text-[#007A85] font-medium text-sm transition-colors"
                  >
                    Learn more
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#005B63] text-white rounded-lg font-medium hover:bg-[#007A85] transition-colors group"
          >
            View All Services
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
